import React from 'react';

class EditTextIcon extends React.Component {
  render() {
    const { width = 18, color = '#C0C0C0' } = this.props;
    return (
      <div className="edit-icon-holder" style={{ width: width }}>
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={width} viewBox="0 0 24 24">
          <path
            fill={color}
            d="M2 6v2h12V6H2m0 4v2h12v-2H2m18.04.13c-.14 0-.28.06-.39.17l-1 1 2.05 2.05 1-1c.22-.21.22-.56 0-.77l-1.28-1.28a.533.533 0 00-.38-.17m-1.97 1.75L12 17.94V20h2.06l6.06-6.07-2.05-2.05M2 14v2h8v-2H2z"
          />
        </svg>
      </div>
    );
  }
}

export default EditTextIcon;
